import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationError } from '@angular/router';
import { TokenService } from './services/api/token.api.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  // @HostListener('document:mousemove', ['$event'])
  // onMouseMove(e) {
  //   //console.log(e);
  // }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    // console.log("Catchhub-> Key Down");
    this.tokenService.resetUserIdleTime();
  }

  @HostListener('document:click', ['$event']) documentClick(event: Event): void {
    // console.log("Catchhub-> Click");
    this.tokenService.resetUserIdleTime();
  }

  constructor(private tokenService: TokenService, private router: Router) {
    // go.Diagram.licenseKey = environment.gokey;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        this.router.navigate(['/']);
      }
    });
  }

  ngOnInit(): void {
    if (environment.production) {
      window.addEventListener('beforeunload', function (e) {
        const confirmationMessage = 'o/';
        e.returnValue = confirmationMessage;
        return confirmationMessage;
      });
    }
  }
}
